import { render, staticRenderFns } from "./BookingWishlistListItem.vue?vue&type=template&id=67feabdc&scoped=true&"
import script from "./BookingWishlistListItem.vue?vue&type=script&lang=js&"
export * from "./BookingWishlistListItem.vue?vue&type=script&lang=js&"
import style0 from "./BookingWishlistListItem.vue?vue&type=style&index=0&id=67feabdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67feabdc",
  null
  
)

export default component.exports